module.exports = __webpack_public_path__ + "Vector 1.svg?de5093a61a79aac91088c5063f901054";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vectors/Vector 1.svg
// module id = 1078
// module chunks = 0